var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7497 0.179777C13.0251 -0.0599258 13.4313 -0.0599258 13.7067 0.179777L17.5616 3.56545V2.51562C17.5616 1.92041 18.0445 1.39707 18.6449 1.39707H22.256C22.8563 1.39707 23.3393 1.92041 23.3393 2.51562V8.63848L25.9845 10.9609C26.2824 11.2215 26.3095 11.6393 26.007 11.9762C25.7859 12.2727 25.3254 12.2996 25.0275 11.9986L23.3393 10.5162V19.4062C23.3393 21.3918 21.7234 23 19.7282 23H6.72822C4.73398 23 3.11711 21.3918 3.11711 19.4062V10.5162L1.42846 11.9986C1.12919 12.2996 0.672793 12.2727 0.408911 11.9762C0.144984 11.6393 0.173512 11.2215 0.472602 10.9609L12.7497 0.179777ZM21.8949 7.37168V2.875H19.006V4.83359L21.8949 7.37168ZM4.56155 9.28535V19.4062C4.56155 20.5967 5.53204 21.5625 6.72822 21.5625H9.61711V14.375C9.61711 13.5799 10.2626 12.9375 11.0616 12.9375H15.3949C16.1938 12.9375 16.8393 13.5799 16.8393 14.375V21.5625H19.7282C20.9244 21.5625 21.8949 20.5967 21.8949 19.4062V9.28535L13.2282 1.67738L4.56155 9.28535ZM11.0616 14.375V21.5625H15.3949V14.375H11.0616Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0634d85c9e13abdb5cb85a3d2c8aa17a.svg";
export { ForwardRef as ReactComponent };